// A command to paste into a terminal, with a copy button.
import { Check, Copy } from "@phosphor-icons/react";
import { useState } from "react";
import { Button } from "rizzui";

import { useT } from "../i18n";

export function CopyBlock({ text, label }: { text: string; label: string }) {
  const t = useT().vpn.connect;
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard?.writeText(text);
    setCopied(true);
  };
  return (
    <div className="relative">
      <pre aria-label={label} className="m-0 max-h-48 overflow-auto whitespace-pre-wrap break-all rounded-lg bg-gray-1000 p-3 pe-24 font-mono text-[12px] leading-5 text-gray-0 dark:bg-gray-100 dark:text-gray-900">
        {text}
      </pre>
      <Button size="sm" variant="outline" className="absolute end-2 top-2 gap-1 bg-gray-0" onClick={() => void copy()}>
        {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />} {copied ? t.copied : t.copy}
      </Button>
    </div>
  );
}
